import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "GestionPage",
    data() {
        let ss = new MainService();
        return {
            msg: "GestionPage",
            ss: ss,
            ajax: {
                "url": ss.indexGestion(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'Gestion', name: 'Gestion', title: 'Gestion' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            // unidadAcademicas: [],
            gestion: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newGestion() {
            this.gestion = {};
            this.$refs['frm-gestion'].show();
        },
        showGestion(id) {
            console.log("show");
            
            this.isLoading=true;
            this.ss.showGestion(id).then(
                (result) => {
                    let response = result.data;
                    this.gestion = response.data;
                    this.$refs['view-gestion'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editGestion() {
            this.$refs['frm-gestion'].show();
            this.$refs['view-gestion'].hide();
        },
        cancelGestion() {
            if (this.gestion.id) {
                this.$refs['view-gestion'].show();
            }
            this.$refs['frm-gestion'].hide();
        },
        saveGestion() {
            this.ss.storeGestion(this.gestion).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-gestion'].hide();
                    this.$refs['datatable-gestion'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        destroyGestion() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyGestion(this.gestion)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-gestion'].hide();
                                this.$refs['datatable-gestion'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Gestion').on('click', (evt) => {
                console.log("evento click");
                const data = window.$(evt.target)[0].id;
                this.showGestion(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
